module.exports = __webpack_public_path__ + "static/media/Admin.2f9a4759.svg";